<script lang="ts">
import { defineComponent, computed, inject, PropType, onMounted, onUnmounted,ref,Ref } from 'vue';
import permissions from "@/services/permissions";
import type { Group } from '@/types/Groups';
import { useGroups } from '@/services/Groups';
import { Member } from '@/types/Member'
import { Media } from '@/types/Media';
import { eventBus } from '@/services/eventBus';
import { ChevronRightIcon,FolderIcon } from "@heroicons/vue/24/solid";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import draggable from 'vuedraggable'
export default defineComponent({
	name: 'TreeNode',
	components: {
		FolderIcon,
		Accordion, AccordionContent, AccordionItem, AccordionTrigger,
		ChevronRightIcon
	},
	props: {
		open: {
			type: Boolean,
			default: false,
			requierd: false
		},
		group: {
			type: Object as PropType<Group>,
			required: true,
		},
		selectedGroup: {
			type: Number,
			required: false,
		},
		draggedOver: {
			type: Object as PropType<Ref<number | null>>,
			required: false,
			default: () => ({ value: false }), //
		},
		folderHover: {
			type: Object as PropType<Ref<Record<string, boolean>>>,
			required: false,
		},
	},
	emits: ['select-group', 'drop-item', 'hover-folder', 'leave-folder'],
	setup(props, { emit }) {
		const userInfo = inject<Ref<Member> | null>('userInfo', null);
		const vhostId = inject<Ref<string> | null>('vhostId', null);
		const { checkPermission  } = permissions();
		const { addMediaToGroup } = useGroups();
		const highlightedId = ref<number | null>(null);
		const selected = ref(false);
		const draggedMedia = ref<Media|null>(null);
		const handleDrop = async (id: number, event: DragEvent) => {
			if(draggedMedia && draggedMedia.value) {
				emit('drop-item', id, event);
				if(id && id>0) {
				await addMediaToGroup(id, draggedMedia.value.id);
				}
			}
			highlightedId.value = null;
		};
		const defaultAccordionStatus = computed(() => {
			if (selected.value) {
				return `group-${props.group.id}`;
			}
			return `closedGroup-${props.group.id}`;
		});

		const hoverFolder = (id: number) => {
			emit('hover-folder', id);
		};

		const leaveFolder = (id: number) => {
			emit('leave-folder', id);
		};
		const handleDragStart = (media: any) => {
			draggedMedia.value = media;
		};

		const selectGroup = (id: number) => {
			emit('select-group', id);
		};/*
		const getDefaultAccordionStatus = (id: number) => {
			if( selected ) {
				console.log('selected should open',id);
				return "group-"+id;
			}
			return 'closedGroup-'+id;
		};*/
		const onDragOver = (id: number) => {
			selected.value=true;
			highlightedId.value=id;
		};
		const onDragLeave = () => {
			highlightedId.value = null; // Remove the highAlight when the drag leaves
		};

		onMounted(() => {
			eventBus.on('drag-start', handleDragStart);
			selected.value=props.open;
		});

		onUnmounted(() => {
			eventBus.off('drag-start', handleDragStart);
		});

		return { handleDrop, hoverFolder, leaveFolder, selectGroup,defaultAccordionStatus, onDragLeave,onDragOver,highlightedId,selected };
	},
});
</script>

<template>
	<div class="tree-node py-0">
		<drop class="drop" @drop="handleDrop(group.id, $event)" @dragover="draggedOver.value = group.id" @dragleave="draggedOver.value = null"> 
		<div>
			<Accordion type="multiple" collapsible v-if="group.children && group.children.length" :default-value="['group-'+group.id]">
			<AccordionItem :value="defaultAccordionStatus" class="border-0">
			<AccordionTrigger class="py-0">
			<div @click="selectGroup(group.id)" class=" cursor-pointer text-xs font-normal text-left flex items-center justify-start  text-foreground"  @dragleave="onDragLeave" @dragover.prevent="onDragOver(group.id)" :class="{'border-2 border-dashed  border-primary ':group.id==highlightedId,'border-2 border-transparent':group.id!=highlightedId}">
				<div :class="{'text-primary':selectedGroup==group.id}"><FolderIcon class="text-foreground h-3.5 w-3.5"/></div><div  :class="{'text-primary':selectedGroup==group.id}" class="pl-1.5 truncate">{{ group.name }}</div>
			</div>
			</AccordionTrigger>
			<!-- Nested TreeNode if children exist -->
			<AccordionContent class="pb-0">
			<TreeNode v-if="group.children && group.children.length" v-for="child in group.children" :key="child.id" :group="child" :selectedGroup="selectedGroup" @select-group="selectGroup" @drop-item="handleDrop"  class="ml-6" :open="selected"/>
			</AccordionContent>
			</AccordionItem>
			</Accordion>
			<div v-else>
				<div @click="selectGroup(group.id)" class="text-xs font-normal  text-left cursor-pointer flex justify-start text-foreground " :class="{'border-2 border-dashed   border-primary ':group.id==highlightedId, 'border-2  border-transparent':group.id!=highlightedId}"   @dragleave="onDragLeave" @dragover.prevent="onDragOver(group.id)">
					<div><FolderIcon class="text-foreground h-3.5 w-3.5"/></div><div  :class="{'text-primary':selectedGroup==group.id}" class="pl-1.5 truncate">{{ group.name }}</div>
				</div>
			</div>
		</div>
		</drop>
	</div>
</template>
